export interface IStoreCategories {
    fullProductRange: boolean;
    bathroom: boolean;
    selectedProduct: boolean;
    flagship: boolean;
    contractPartners: boolean;
}

/**
 * Enum of keys in PIM used to tie a product to a dealer.
 * Lowercase to save .toLowerCase() calls as these will only be used for recognizing query params.
 */
export enum MontanaDealerKeys {
    Bathroom = 'bathroom',
    ContractPartner = 'contractpartner',
    FullProductRange = 'fullproductrange',
    ShowroomsFlagship = 'showroomsflagship',
    SelectedProduct = 'selectedProduct',
}
